import { TUserAgreementDto } from '@r1-frontend/api-domru/core-profile/v2/user/agreements';

import { InferValueTypes } from '~/src/store';
import * as actions from '~/src/store/actions/agreements';
import { EAction } from '~/src/store/actionTypes/agreements';

export type TAgreement = TUserAgreementDto
export type TAgreements = TAgreement[]

export type TAgreementsState = {
    status: 'init' | 'loading' | 'complete' | 'error',
    list: TAgreements,
}

const initialState: TAgreementsState = {
    status: 'init',
    list: [],
};

export type TAction = ReturnType<InferValueTypes<typeof actions>>

const reducer = (state: TAgreementsState = initialState, action: TAction) => {
    switch (action.type) {
        case EAction.SetStatus:
            return {
                ...state,
                status: action.payload,
            };
        case EAction.SetAgreements:
            return {
                ...state,
                list: action.payload.agreements,
            };
        default:
            return state;
    }
};

export default reducer;
